module.exports = __webpack_public_path__ + "img/avatar_5.829c8bbf.svg";